import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import successImg from '../../../assets/img/icon/success_gif.gif'
import AuthHeader from '../../../components/Navbar/AuthHeader'
import { FaCheckCircle, FaRegTimesCircle } from 'react-icons/fa'
import CardsProgressSteps from '../../../components/ProgressStep/CardsProgressSteps'
import { fetchWallets, updateTransactionProcess, verifyTransaction } from '../../../actions/payments'
import { getAuthenticatedUser } from '../../../actions/auth'
import { useDispatch } from 'react-redux'

function AddMoneyFailed() {
    const navigate = useNavigate()
    const location = useLocation();
    // const amount = 200;
    // const currencyCode = "NGN";
    const { amount, currencyCode } = location.state || {};
    const isPayloadEmpty = !amount || !currencyCode;

    // useEffect(() => {
    //     if (isPayloadEmpty) {
    //         navigate("/user/add_money", { replace: true });
    //         return;
    //     }
    // }, [isPayloadEmpty, navigate]);

    const goToTxnPage = () => {
        navigate('/user/transactions');
        // implement receipt download logic
    }

    // useEffect(() => {
    //     const key = 'hasReloaded_AddMoneyFailed';
    //     const lastPath = sessionStorage.getItem('lastPath');
    //     const currentPath = location.pathname + location.search;

    //     if (lastPath !== currentPath) {
    //         sessionStorage.setItem('lastPath', currentPath);
    //         sessionStorage.setItem(key, 'false');
    //     }

    //     const hasReloaded = sessionStorage.getItem(key);

    //     if (hasReloaded !== 'true') {
    //         sessionStorage.setItem(key, 'true');
    //         const timer = setTimeout(() => {
    //             window.location.reload();
    //         }, 3000); 

    //         return () => clearTimeout(timer);
    //     }
    // }, [location]);
    

    return (
        <div>
            <div className="create__card__page send__money__page pt-2">

                <div className='auth__container__box mt-4 shadow-none rounded'>
                    <FaRegTimesCircle size={80} color="#FF2525" className="mb-4 d-flex justify-content-center mx-auto" />
                    <h3 className=''>Failed</h3>
        
                    <p className='auth__text '>
                        {isPayloadEmpty ? 
                            'Your attempt to verify your transaction was unsuccessful. Please contact support for further assistance.'
                            : 'Your attempt to add money to your wallet was unsuccessful. Please try again.' 
                        }
                    </p>

                    <h1 className='text-center my-2'>{currencyCode} {amount}</h1>

                    <button onClick={goToTxnPage} className='btn btn-primary w-100 mt-4'>
                        See transactions
                    </button>

                    <button onClick={() => navigate('/user/add_money')} className='btn btn-outline-light text-dark w-100 mt-3'>
                        Go to Add Money
                    </button>
                </div>


            </div>
        </div>
    )
}

export default AddMoneyFailed;